import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-claim-settled',
  templateUrl: './claim-settled.component.html',
  styleUrls: ['./claim-settled.component.scss']
})
export class ClaimSettledComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
